import { gsap } from 'gsap/dist/gsap';
import { Swiper, Lazy } from 'swiper';

Swiper.use([Lazy]);


export default {
  init() {

    /**************************************************************
    -> Open/close profile lightboxes
    **************************************************************/
    function triggerProfileLightbox() {
      const buttonContainers = Array.from(Array.from(document.querySelectorAll('[data-button-lightbox-bio]')))
      
      buttonContainers.forEach(container => {
        const button = container.querySelector('button')
        const index = container.dataset.index
    
        button.addEventListener('click', () => {
          const lightbox = document.querySelector(`[data-lightbox-profile][data-index="${index}"]`)
          const lightboxContainer = lightbox.querySelector('[data-container]')
          const closeTriggers = Array.from(lightbox.querySelectorAll('[data-lightbox-close]'))
          
          document.body.style.overflow = 'hidden'
          gsap.to(lightbox, { opacity: 1, pointerEvents: 'all', delay: 0.3})
          gsap.to(lightboxContainer, { y: 0, delay: 0.3 })
          
          closeTriggers.forEach(close => {
            close.addEventListener('click', () => {
              document.body.style.overflow = 'initial'
              gsap.to(lightbox, { opacity: 0, pointerEvents: 'none' })
              gsap.to(lightboxContainer, { y: '25px' })
            })
          })
        })
      })
    }
    
    triggerProfileLightbox()

    /**************************************************************
    -> Open/close publication lightboxes
    **************************************************************/
    function triggerPublicationsLightbox() {
      const buttonContainers = Array.from(Array.from(document.querySelectorAll('[data-button-lightbox-publication]')))
      
      buttonContainers.forEach(container => {
        const button = container.querySelector('button')
        const index = container.dataset.index
    
        button.addEventListener('click', () => {
          const lightbox = document.querySelector(`[data-lightbox-publication][data-index="${index}"]`)
          const lightboxContainer = lightbox.querySelector('[data-container]')
          const closeTriggers = Array.from(lightbox.querySelectorAll('[data-lightbox-close]'))
          
          document.body.style.overflow = 'hidden'
          gsap.to(lightbox, { opacity: 1, pointerEvents: 'all', delay: 0.3})
          gsap.to(lightboxContainer, { y: 0, delay: 0.3 })
          
          closeTriggers.forEach(close => {
            close.addEventListener('click', () => {
              document.body.style.overflow = 'initial'
              gsap.to(lightbox, { opacity: 0, pointerEvents: 'none' })
              gsap.to(lightboxContainer, { y: '25px' })
            })
          })
        })
      })
    }
    
    triggerPublicationsLightbox()
    /**************************************************************
    -> Open/close profile lightboxes
    **************************************************************/
    function triggerLightbox() {
      const buttonContainers = Array.from(Array.from(document.querySelectorAll('[data-button-lightbox-bio]')))
      
      buttonContainers.forEach(container => {
        const button = container.querySelector('button')
        const index = container.dataset.index
    
        button.addEventListener('click', () => {
          const lightbox = document.querySelector(`[data-lightbox-profile][data-index="${index}"]`)
          const lightboxContainer = lightbox.querySelector('[data-container]')
          const close = lightbox.querySelector('[data-lightbox-close]')
          
          document.body.style.overflow = 'hidden'
          gsap.to(lightbox, { opacity: 1, pointerEvents: 'all', delay: 0.3})
          gsap.to(lightboxContainer, { y: 0, delay: 0.3 })
          
          close.addEventListener('click', () => {
            document.body.style.overflow = 'initial'
            gsap.to(lightbox, { opacity: 0, pointerEvents: 'none' })
            gsap.to(lightboxContainer, { y: '25px' })
          })
        })
      });
    }
    
    triggerLightbox()

    /**************************************************************
    -> Publication Swiper instance
    **************************************************************/
    function publicationSwiper() {
      const publicationSwiper = new Swiper('.publications .swiper-container', {
        slidesPerView: 1,
        parallax: true,
        threshold: 9999,
        speed: 0,
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true,
        },
        watchSlidesVisibility: true,
      })

      // Wire up next/prev buttons
      const prevButtons = Array.from(document.querySelectorAll('.publications .prev'))
      const nextButtons = Array.from(document.querySelectorAll('.publications .next'))
      const images = Array.from(document.querySelectorAll('.publications .image'))
      const quotes = Array.from(document.querySelectorAll('.publications .quote'))
      const texts = Array.from(document.querySelectorAll('.publications .text'))
      const paginationCurrent = Array.from(document.querySelectorAll('.publications .pagination-current'))

      function slideElementsOut() {
        const tl = gsap.timeline()

        tl.to(images, { opacity: 0, duration: 0.25 })
        tl.to(quotes, { opacity: 0, duration: 0.25 }, '>-0.15')
        tl.to(texts, { opacity: 0, duration: 0.25 }, '>-0.15')
      }

      function slideElementsIn() {
        const tl = gsap.timeline()

        tl.to(texts, { opacity: 1, duration: 0.25 })
        tl.to(quotes, { opacity: 1, duration: 0.25 }, '>-0.15')
        tl.to(images, { opacity: 1, duration: 0.25 }, '>-0.15')
      }

      function updatePagination() {
        paginationCurrent.forEach(number => {
          number.innerHTML = publicationSwiper.activeIndex + 1
        });
      }

      prevButtons.forEach(button => {
        button.addEventListener('click', () => {
          if (publicationSwiper.activeIndex !== 0) {
            slideElementsOut() 

            setTimeout(() => {
              publicationSwiper.slidePrev()
              updatePagination()
              slideElementsIn() 
            }, 750)
          }
        })
      })
      
      nextButtons.forEach(button => {
        button.addEventListener('click', () => {
          
          if (publicationSwiper.activeIndex + 1 < publicationSwiper.slides.length) {
            slideElementsOut() 
            
            setTimeout(() => {
              publicationSwiper.slideNext()
              updatePagination()
              slideElementsIn() 
            }, 750)
          }
        })
      })
    }

    publicationSwiper()

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/template-expertise.js